import { passwordSchema } from "../../../shared/lib/schemas/common.schema";
import { z } from "zod";

export const resetPasswordFormSchema = z.object({
    password: passwordSchema,
    confirmPassword: passwordSchema,
}).refine((data) => data.password === data.confirmPassword, {
    path: ["confirmPassword"],
    message: "Passwords do not match",
})


export type ResetPasswordFormType = z.infer<typeof resetPasswordFormSchema>